import moment from "moment";
import toast from "react-hot-toast";
import { COMMON_DATE_FORMAT, CRM_DATE_FORMAT } from "../constant";

export function debounce(func: Function, delay: number) {
  let timeoutId: NodeJS.Timeout;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export function shortenFileName(filename: string, maxLength = 20) {
  const extIndex = filename.lastIndexOf(".");
  const extension = filename.slice(extIndex);
  const nameWithoutExt = filename.slice(0, extIndex);

  const nameParts = nameWithoutExt.split("-");
  const nameLength = nameWithoutExt.length;

  if (nameLength > maxLength) {
    return `${nameWithoutExt.slice(0, 6)}....${nameParts
      .slice(-2)
      .join("-")}${extension}`;
  }
  return filename;
}

export const formatPhoneNumber = (value: string, ifNull = "-") => {
  value = value.replace(/\D/g, "");
  return value ? value.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3") : ifNull;
};

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

export const convertCRMDate = (date: string): Date | null => {
  date ||= "";
  if (date.length > 0) return moment(date, CRM_DATE_FORMAT).toDate();
  return null;
};

export const convertToCRMDate = (date: Date): string => {
  if (date) return moment(date).format(CRM_DATE_FORMAT);
  return "";
};

export const formatDate = (date: Date, ifNull = "-"): string => {
  if (date) return moment(date).format(COMMON_DATE_FORMAT);
  return ifNull;
};

export const USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const makeOptionsFromArray = (value: string[]) => {
  return value.map((item) => ({ label: item, value: item }));
};

export function combineHandlers<T>(
  ...handlers: Array<((value: T) => void) | undefined>
): (value: T) => void {
  return (value: T) => {
    handlers.forEach((handler) => {
      if (handler) handler(value);
    });
  };
}

export const handleApiErrorToast = (
  error: any,
  fallbackMessage = "Something went wrong"
) => {
  const responseData = error?.response?.data;
  if (Array.isArray(responseData?.errors) && responseData.errors.length > 0) {
    responseData.errors.forEach((err: any) => {
      const msg = typeof err === "string" ? err : err?.message;
      if (msg) {
        toast.error(msg, { position: "bottom-center" });
      }
    });
  } else {
    const errorMessage =
      responseData?.data?.message ||
      responseData?.message ||
      error?.message ||
      fallbackMessage;
    toast.error(errorMessage, {
      position: "bottom-center",
    });
  }
};

export const calculateLineItemsTotal = (lineItems: any[] = []): number => {
  return lineItems.reduce((sum: number, item: any) => {
    const price = parseFloat(
      String(item.product_retail_price || 0).replace(/[^0-9.-]+/g, "")
    );
    const qty = parseInt(item.quantity || 1, 10);
    return sum + (isNaN(price) ? 0 : price) * (isNaN(qty) ? 1 : qty);
  }, 0);
};
